import { makeAutoObservable, computed } from "mobx";
import { TabItems } from "../types/privilege";
import { cutZero, numberFormat } from "@/utilities/number";
import { getPriceErrorMessage, getTargetLinkErrorMessage, getTextErrorMessage } from "@BZA/ToolCenter/campaignCenter/campaignUtils/tools";

const initialTabList = [
  {
    tabType: 0,
    tabLabel: "",
    targetUrl: "",
    darkTheme: false,
    contentList: [],
    activeContentKey: 0,
  },
  {
    tabType: 0,
    tabLabel: "",
    targetUrl: "",
    darkTheme: false,
    contentList: [],
    activeContentKey: 0,
  },
  {
    tabType: 0,
    tabLabel: "",
    targetUrl: "",
    darkTheme: true, // 每个卡片都有
    contentList: [],
    activeContentKey: 0,
  },
  {
    tabType: 0,
    tabLabel: "",
    targetUrl: "",
    darkTheme: false,
    contentList: [],
    activeContentKey: 0,
  },
  {
    tabType: 0,
    tabLabel: "",
    targetUrl: "",
    darkTheme: false,
    title: "",
    titleTargetUrl: "",
    description: "",
    descriptionTargetUrl: "",
    subTitles: [],
    activeSubTitleKey: 0,
    introduce: "",
    introduceTargetUrl: "",
    introDespcription: "",
    introDespcriptionTargetUrl: "",
    introButtons: [],
    activeButtonKey: 0,
    introImageUrl: "", // 介绍图片
    introImageTargetUrl: "", // 介绍图片链接
  },
];
export default class ValidateStore {
  tabList: string;
  active: boolean;
  fullScreenValidDatas: string;
  privilegeStore;
  constructor (privilegeStore: any) {
    /**
     * state
     */
    this.tabList = JSON.stringify(initialTabList);
    this.active = false;
    this.fullScreenValidDatas = JSON.stringify({
      extraTemplateType: "", // 1: GIF首帧图，2: 图片
      duration: "", // 时长
      targetLink: "", // 跳转地址
      videoUrl: "", // 视频地址
      imageUrl: "", // 视频ID
    });
    this.privilegeStore = privilegeStore;
    makeAutoObservable(this);
  }

  subValid (index: number, _tabType: number, type?: "view" | "store") {
    return computed(() => {
      const tabList = JSON.parse(this.tabList) as TabItems[];
      const item = tabList[index] || {};
      const {
        tabType,
        contentList = [],
        // 介绍卡2
        subTitles = [],
        introButtons = [],
        title,
        titleTargetUrl,
        description,
        descriptionTargetUrl,
        introduce = "",
        introduceTargetUrl = "",
        introDespcription = "",
        introDespcriptionTargetUrl = "",
        introImageUrl = "", // 介绍图片
        introImageTargetUrl = "", // 介绍图片链接
      } = item;
      const subValidates = [
        () => {
          const isContentValid = contentList.map((item) => {
            const {
              targetUrl = "",
              imageUrl,
              imageTargetUrl = "",
              title = "",
              titleTargetUrl = "",
              price = "",
              priceUnit = "",
              descriptionTargetUrl = "",
              button = "",
              buttonTargetUrl = "",
            } = item || {};
            return !targetUrl && !imageUrl && !imageTargetUrl && !title && !titleTargetUrl && !price && !priceUnit && !descriptionTargetUrl && !button && !buttonTargetUrl;
          });
          return {
            result: isContentValid.every((item) => item),
            contentList: isContentValid
          };
        },
        () => {
          const isContentValid = contentList.map((item) => {
            const {
              targetUrl = "",
              imageUrl,
              imageTargetUrl = "",
              title = "",
              titleTargetUrl = "",
              description = "",
              descriptionTargetUrl = "",
              button = "",
              buttonTargetUrl = "",
            } = item || {};
            return !targetUrl && !imageUrl && !imageTargetUrl && !title && !titleTargetUrl && !description && !descriptionTargetUrl && !button && !buttonTargetUrl;
          });
          return {
            result: isContentValid.every((item) => item),
            contentList: isContentValid
          };
        },
        () => {
          const isContentValid = contentList.map((item) => {
            const {
              targetUrl = "",
              imageUrl,
              imageTargetUrl = "",
              title = "",
              titleTargetUrl = "",
              description = "",
              descriptionTargetUrl = "",
              button = "",
              buttonTargetUrl = "",
            } = item || {};
            return !targetUrl && !imageUrl && !imageTargetUrl && !title && !titleTargetUrl && !description && !descriptionTargetUrl && !button && !buttonTargetUrl;
          });
          return {
            result: isContentValid.every((item) => item),
            contentList: isContentValid
          };
        },
        () => {
          const isContentValid = contentList.map((item) => {
            const {
              targetUrl = "",
              imageUrl,
              imageTargetUrl = "",
            } = item || {};
            return !targetUrl && !imageUrl && !imageTargetUrl;
          });
          return {
            result: isContentValid.every((item) => item),
            contentList: isContentValid
          };
        },
        () => {
          const isSubTitlesValid = subTitles.map((item) => {
            const {
              title = "",
              titleTargetUrl,
              description,
              descriptionTargetUrl,
            } = item || {};
            return !title && !titleTargetUrl && !description && !descriptionTargetUrl;
          });
          const isIntroButtonsValid = introButtons.map((item) => {
            const {
              title = "",
              titleTargetUrl,
            } = item || {};
            return !title && !titleTargetUrl;
          });
          const result = isSubTitlesValid.every((item) => item) && isIntroButtonsValid.every((item) => item) && !title && !titleTargetUrl && !description && !descriptionTargetUrl && !introduce && !introduceTargetUrl && !introDespcription && !introDespcriptionTargetUrl && !introImageUrl && !introImageTargetUrl;
          return {
            result,
            subTitles: isSubTitlesValid,
            introButtons: isIntroButtonsValid,
            title,
            titleTargetUrl,
            description,
            descriptionTargetUrl,
            introduce,
            introduceTargetUrl,
            introDespcription,
            introDespcriptionTargetUrl,
            introImageUrl,
            introImageTargetUrl,
          };
        },
        () => {
          const isContentValid = contentList.map((item) => {
            const {
              targetUrl = "",
              imageUrl,
              imageTargetUrl = "",
              title = "",
              titleTargetUrl = "",
              description = "",
              descriptionTargetUrl = "",
            } = item || {};
            return !targetUrl && !imageUrl && !imageTargetUrl && !title && !titleTargetUrl && !description && !descriptionTargetUrl;
          });
          return {
            result: isContentValid.every((item) => item),
            contentList: isContentValid
          };
        },
      ];
      return _tabType > 0 ? subValidates[_tabType - 1]() : { result: true };
    }).get();
  }

  get topLevelValid () {
    const { tabTypeList } = this.privilegeStore;
    const tabList = JSON.parse(this.tabList) as TabItems[];
    const validArr = tabList.map((item, index: number) => {
      const _tabType = tabTypeList[index] || 0;
      const {
        tabType,
        tabLabel,
        targetUrl
      } = item;
      let isValid = !tabLabel && !targetUrl && !tabType;
      const isSubValid = this.subValid(index, Number(_tabType), "store").result;
      return isValid && isSubValid;
    });
    return validArr;
  }

  get validateData () {
    return JSON.parse(this.tabList) as TabItems[];
  }

  get fullScreenValids () {
    return JSON.parse(this.fullScreenValidDatas || "{}");
  }

  get typeValid () {
    const datas = JSON.parse(this.fullScreenValidDatas || "{}");
    return datas.extraTemplateType;
  }

  get videoValid () {
    const datas = JSON.parse(this.fullScreenValidDatas || "{}");
    return datas.videoUrl;
  }

  get imageValid () {
    const datas = JSON.parse(this.fullScreenValidDatas || "{}");
    return datas.imageUrl;
  }

  get countValid () {
    const datas = JSON.parse(this.fullScreenValidDatas || "{}");
    return datas.duration;
  }

  get targetLinkValid () {
    const datas = JSON.parse(this.fullScreenValidDatas || "{}");
    return datas.targetLink;
  }

  setAddDatas () {
    this.tabList = JSON.stringify(initialTabList);
    this.active = false;
    this.fullScreenValidDatas = JSON.stringify({
      extraTemplateType: "", // 1: GIF首帧图，2: 图片
      duration: "", // 时长
      targetLink: "", // 跳转地址
      videoUrl: "", // 视频地址
      imageUrl: "", // 视频ID
    });
  }

  setTabItem (index: number, key: string, value: any) {
    const newList = JSON.parse(this.tabList) as TabItems[];
    (newList[index] as any)[key] = value;
    this.tabList = JSON.stringify(newList);
  }

  setPriceAndUnit (index: number, contentIndex: number, price: number, unit: any) {
    const newList = JSON.parse(this.tabList) as TabItems[];
    const contentList = (newList[index] as any)?.contentList;
    if (contentList && contentList[contentIndex]) {
      (contentList[contentIndex] as any).description = `${cutZero(numberFormat(price, 2))}${unit}`;
    }
    this.tabList = JSON.stringify(newList);
  }

  setContentItem (index: number, contentIndex: number, key: string, value: any, contentKey = "contentList") {
    const newList = JSON.parse(this.tabList) as TabItems[];
    const contentList = (newList[index] as any)?.[contentKey];
    if (contentList && contentList[contentIndex]) {
      (contentList[contentIndex] as any)[key] = value;
    }
    this.tabList = JSON.stringify(newList);
  }

  setActive (value: boolean) {
    this.active = value;
  }

  setFullValidateDatas (datas: TabItems[]) {
    const newList = datas.map((item) => {
      const {
        tabType,
        tabLabel,
        targetUrl,
        contentList = [],
        // 介绍卡2
        subTitles = [],
        introButtons = [],
        title,
        titleTargetUrl,
        description,
        descriptionTargetUrl,
        introduce = "",
        introduceTargetUrl = "",
        introDespcription = "",
        introDespcriptionTargetUrl = "",
        introImageUrl = "", // 介绍图片
        introImageTargetUrl = "", // 介绍图片链接
      } = item;
      const handleNewItemMethods = [
        () => {
          return {
            tabType: Number(tabType) === 0 ? "请选择卡片类型" : "",
            tabLabel: getTextErrorMessage(tabLabel, true, "卡片标题", 16),
            targetUrl: getTargetLinkErrorMessage(targetUrl, true, "主跳转链接"),
          };
        },
        () => {
          const newContentList = contentList.map((content) => {
            const {
              targetUrl = "",
              imageUrl,
              imageTargetUrl = "",
              title = "",
              titleTargetUrl = "",
              price = "",
              priceUnit = "",
              descriptionTargetUrl = "",
              button = "",
              buttonTargetUrl = "",
            } = content || {};
            return {
              targetUrl: getTargetLinkErrorMessage(targetUrl, false, "主跳转链接"),
              imageUrl: imageUrl ? "" : "请上传图片",
              imageTargetUrl: getTargetLinkErrorMessage(imageTargetUrl, false, "图片跳转链接"),
              title: getTextErrorMessage(title, true, "标题", 28),
              titleTargetUrl: getTargetLinkErrorMessage(titleTargetUrl, false, "标题跳转链接"),
              price: getPriceErrorMessage(price, true, "价格"),
              priceUnit: priceUnit ? "" : "请选择价格单位",
              descriptionTargetUrl: getTargetLinkErrorMessage(descriptionTargetUrl, false, "描述跳转链接"),
              button: getTextErrorMessage(button, true, "按钮文本", 12),
              buttonTargetUrl: getTargetLinkErrorMessage(buttonTargetUrl, false, "按钮跳转链接"),
            };
          });
          return {
            tabType: Number(tabType) === 0 ? "请选择卡片类型" : "",
            tabLabel: getTextErrorMessage(tabLabel, true, "卡片标题", 16),
            targetUrl: getTargetLinkErrorMessage(targetUrl, true, "主跳转链接"),
            contentList: newContentList,
          };
        },
        () => {
          const newContentList = contentList.map((content) => {
            const {
              targetUrl = "",
              imageUrl,
              imageTargetUrl = "",
              title = "",
              titleTargetUrl = "",
              description = "",
              descriptionTargetUrl = "",
              button = "",
              buttonTargetUrl = "",
            } = content || {};
            return {
              targetUrl: getTargetLinkErrorMessage(targetUrl, false, "主跳转链接"),
              imageUrl: imageUrl ? "" : "请上传图片",
              imageTargetUrl: getTargetLinkErrorMessage(imageTargetUrl, false, "图片跳转链接"),
              title: getTextErrorMessage(title, true, "标题", 28),
              titleTargetUrl: getTargetLinkErrorMessage(titleTargetUrl, false, "标题跳转链接"),
              description: getTextErrorMessage(description, true, "描述", 28),
              descriptionTargetUrl: getTargetLinkErrorMessage(descriptionTargetUrl, false, "描述跳转链接"),
              button: getTextErrorMessage(button, true, "按钮文本", 12),
              buttonTargetUrl: getTargetLinkErrorMessage(buttonTargetUrl, false, "按钮跳转链接"),
            };
          });
          return {
            tabType: Number(tabType) === 0 ? "请选择卡片类型" : "",
            tabLabel: getTextErrorMessage(tabLabel, true, "卡片标题", 16),
            targetUrl: getTargetLinkErrorMessage(targetUrl, true, "主跳转链接"),
            contentList: newContentList,
          };
        },
        () => {
          const newContentList = contentList.map((content) => {
            const {
              targetUrl = "",
              imageUrl,
              imageTargetUrl = "",
              title = "",
              titleTargetUrl = "",
              description = "",
              descriptionTargetUrl = "",
              button = "",
              buttonTargetUrl = "",
            } = content || {};
            return {
              targetUrl: getTargetLinkErrorMessage(targetUrl, false, "主跳转链接"),
              imageUrl: imageUrl ? "" : "请上传图片",
              imageTargetUrl: getTargetLinkErrorMessage(imageTargetUrl, false, "图片跳转链接"),
              title: getTextErrorMessage(title, true, "标题", 28),
              titleTargetUrl: getTargetLinkErrorMessage(titleTargetUrl, false, "标题跳转链接"),
              description: getTextErrorMessage(description, true, "描述", 40),
              descriptionTargetUrl: getTargetLinkErrorMessage(descriptionTargetUrl, false, "描述跳转链接"),
              button: getTextErrorMessage(button, true, "按钮文本", 12),
              buttonTargetUrl: getTargetLinkErrorMessage(buttonTargetUrl, false, "按钮跳转链接"),
            };
          });
          return {
            tabType: Number(tabType) === 0 ? "请选择卡片类型" : "",
            tabLabel: getTextErrorMessage(tabLabel, true, "卡片标题", 16),
            targetUrl: getTargetLinkErrorMessage(targetUrl, true, "主跳转链接"),
            contentList: newContentList,
          };
        },
        () => {
          const newContentList = contentList.map((content) => {
            const {
              imageUrl,
              imageTargetUrl = "",
            } = content || {};
            return {
              imageUrl: imageUrl ? "" : "请上传图片",
              imageTargetUrl: getTargetLinkErrorMessage(imageTargetUrl, false, "图片跳转链接"),
            };
          });
          return {
            tabType: Number(tabType) === 0 ? "请选择卡片类型" : "",
            tabLabel: getTextErrorMessage(tabLabel, true, "卡片标题", 16),
            targetUrl: getTargetLinkErrorMessage(targetUrl, true, "主跳转链接"),
            contentList: newContentList,
          };
        },
        () => {
          const newSubTitles = subTitles.map((item) => {
            const {
              title = "",
              titleTargetUrl,
              description,
              descriptionTargetUrl,
            } = item || {};
            return {
              title: getTextErrorMessage(title, true, "标题", 20),
              titleTargetUrl: getTargetLinkErrorMessage(titleTargetUrl, false, "标题跳转链接"),
              description: getTextErrorMessage(description, true, "描述", 24),
              descriptionTargetUrl: getTargetLinkErrorMessage(descriptionTargetUrl, false, "描述跳转链接"),
            };
          });
          const newIntroButtons = introButtons.map((item) => {
            const {
              title = "",
              titleTargetUrl,
            } = item || {};
            return {
              title: getTextErrorMessage(title, true, "按钮文本", 12),
              titleTargetUrl: getTargetLinkErrorMessage(titleTargetUrl, false, "按钮跳转链接"),
            };
          });
          return {
            tabType: Number(tabType) === 0 ? "请选择卡片类型" : "",
            tabLabel: getTextErrorMessage(tabLabel, true, "卡片标题", 16),
            targetUrl: getTargetLinkErrorMessage(targetUrl, true, "主跳转链接"),
            title: getTextErrorMessage(title, true, "标题", 28),
            titleTargetUrl: getTargetLinkErrorMessage(titleTargetUrl, false, "标题跳转链接"),
            description: getTextErrorMessage(description, true, "描述", 60),
            descriptionTargetUrl: getTargetLinkErrorMessage(descriptionTargetUrl, false, "描述跳转链接"),
            subTitles: newSubTitles,
            introduce: getTextErrorMessage(introduce, true, "介绍文本", 16),
            introduceTargetUrl: getTargetLinkErrorMessage(introduceTargetUrl, false, "介绍跳转链接"),
            introDespcription: getTextErrorMessage(introDespcription, true, "介绍描述", 320),
            introDespcriptionTargetUrl: getTargetLinkErrorMessage(introDespcriptionTargetUrl, false, "介绍描述跳转链接"),
            introButtons: newIntroButtons,
            introImageUrl: introImageUrl ? "" : "请上传图片",
            introImageTargetUrl: getTargetLinkErrorMessage(introImageTargetUrl, false, "介绍图片跳转链接"),
          };
        },
        () => {
          const newContentList = contentList.map((content) => {
            const {
              targetUrl = "",
              imageUrl,
              imageTargetUrl = "",
              title = "",
              titleTargetUrl = "",
              description = "",
              descriptionTargetUrl = "",
            } = content || {};
            return {
              targetUrl: getTargetLinkErrorMessage(targetUrl, false, "主跳转链接"),
              imageUrl: imageUrl ? "" : "请上传图片",
              imageTargetUrl: getTargetLinkErrorMessage(imageTargetUrl, false, "图片跳转链接"),
              title: getTextErrorMessage(title, true, "标题", 40),
              titleTargetUrl: getTargetLinkErrorMessage(titleTargetUrl, false, "标题跳转链接"),
              description: getTextErrorMessage(description, true, "描述", 100),
              descriptionTargetUrl: getTargetLinkErrorMessage(descriptionTargetUrl, false, "描述跳转链接"),
            };
          });
          return {
            tabType: Number(tabType) === 0 ? "请选择卡片类型" : "",
            tabLabel: getTextErrorMessage(tabLabel, true, "卡片标题", 16),
            targetUrl: getTargetLinkErrorMessage(targetUrl, true, "主跳转链接"),
            contentList: newContentList,
          };
        },
      ];
      return handleNewItemMethods[tabType]();
    });
    this.tabList = JSON.stringify(newList);
  }

  setFullScreenValid (value: string | number, key: string) {
    const data = JSON.parse(this.fullScreenValidDatas);
    data[key] = value;
    this.fullScreenValidDatas = JSON.stringify(data);
  }

  setFullScreenFullValidate (datas: any) {
    const {
      extraTemplateType = "",
      duration = "",
      targetLink = "",
      videoUrl = "",
      imageUrl = "",
    } = datas || {};
    const validateResult = {
      extraTemplateType: "",
      duration: "",
      targetLink: "",
      videoUrl: "",
      imageUrl: "",
    };
    if (extraTemplateType === undefined || extraTemplateType === "") {
      validateResult.extraTemplateType = "请选择模板类型";
    }
    if (duration !== undefined && !Number.isInteger(Number(duration))) {
      validateResult.duration = "请输入整数";
    } else if (parseInt(duration) < 1 || parseInt(duration) > 5) {
      validateResult.duration = "时长范围1~5秒";
    }
    validateResult.targetLink = getTargetLinkErrorMessage(targetLink, true, "跳转地址");
    if (Number(extraTemplateType) === 1) {
      if (!videoUrl) {
        validateResult.videoUrl = "请上传视频";
      }
      if (!imageUrl) {
        validateResult.imageUrl = "请上传图片";
      }
    }
    if (Number(extraTemplateType) === 2) {
      if (!imageUrl) {
        validateResult.imageUrl = "请上传图片";
      }
    }
    this.fullScreenValidDatas = JSON.stringify(validateResult);
  }
}
